import gql from 'graphql-tag';

export const unfollowRecordsMutation = gql`
  mutation UnfollowRecords($input: UnfollowRecordsMutationInput!) {
    unfollowRecords(input: $input) {
      userErrors {
        path
        message
      }
    }
  }
`;
